import { IconProps } from "../../utils/global-types/global-types";

const LinkEmailEditorIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 18 18"
    className={className ? className : "w-[18px] h-[18px]"}
    {...rest}
  >
    <path
      fill="currentColor"
      d="M3.363 8.583c0-1.225.996-2.22 2.221-2.22H8.45V5H5.584a3.584 3.584 0 0 0-3.582 3.582 3.584 3.584 0 0 0 3.582 3.583H8.45v-1.361H5.584a2.223 2.223 0 0 1-2.22-2.222m2.938.717h5.732V7.867H6.3zM12.749 5H9.883v1.362h2.866c1.225 0 2.221.996 2.221 2.221a2.223 2.223 0 0 1-2.22 2.222H9.882v1.36h2.866a3.584 3.584 0 0 0 3.583-3.582 3.584 3.584 0 0 0-3.583-3.582"
    ></path>
  </svg>
);

export default LinkEmailEditorIcon;
